export default __webpack_public_path__ + "static/media/logo.a0e3334a.svg";